export enum DocumentTabEnum {
  All = 'all',
  Unread = 'unread',
  Favorites = 'favorites',
}
